import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { getOptionsWithTranslateHeader } from '../../../../../lib-os-components/src/public-api';
import { OrderNumberSearchResult } from '../../features/result/spare-parts-result/components/order-number-table/order-number-table.interface';

@Injectable({
    providedIn: 'root',
})
export class OrderNumberService {
    public constructor(private http: HttpClient) {}

    public getOrder(orderNumber: string): Observable<OrderNumberSearchResult> {
        return this.http.get<OrderNumberSearchResult>(
            `/api/order-search?order_number=${orderNumber}`,
            getOptionsWithTranslateHeader()
        );
    }
}
